import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import * as S from '../styles'

interface SuccessRequestTreatmentProps {
  daysToAuthorizeProcedure?: number
  isAuthorizationGuide?: boolean
  professionalRoleText?: 'psicólogo' | 'psiquiatra'
}

export const SuccessRequestTreatment = ({
  daysToAuthorizeProcedure,
  isAuthorizationGuide = false,
  professionalRoleText = 'psicólogo'
}: SuccessRequestTreatmentProps): JSX.Element => {
  if (isAuthorizationGuide) {
    return (
      <>
        <S.StyledCheckIcon />
        <S.Title>
          Solicitação de consulta com {professionalRoleText} aprovada com sucesso!
        </S.Title>
        <S.TextWrapper>
          <Typography variant='content2'>
            Você já pode agendar sua(s) consulta(s).
          </Typography>
        </S.TextWrapper>
      </>
    )
  }

  return (
    <>
      <S.StyledCheckIcon />
      <S.Title>
        Sua consulta com psicólogo foi solicitada!
      </S.Title>
      <S.TextWrapper>
        <Typography variant='content2'>
        Pediremos a autorização para que você possa realizá-la e <b>em até {daysToAuthorizeProcedure} dias úteis</b> você receberá a confirmação por e-mail e sms.
        </Typography>
        <Typography variant='content2'>
          Enquanto você aguarda, ainda não será possível agendar consultas, mas você já pode conhecer nossos psicólogos.
        </Typography>
      </S.TextWrapper>
  </>
  )
}
